<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="60px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手">
                  <el-input v-model="queryForm.buyerName" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-alert title="如需增加买手等级，请联系IT" type="warning" show-icon></el-alert>
    <el-table :data="tableData">
      <el-table-column prop="buyerLevelId" label="等级"></el-table-column>
      <el-table-column prop="delayTime" label="订单显示延迟时间（分）"></el-table-column>
      <el-table-column label="买手" width="500">
        <template slot-scope="scope">
          <div class="buyer-name">{{ scope.row.buyerList && scope.row.buyerList.map(item => item.buyerName).join(', ') }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-link type="primary" @click="showForm(scope.row)">设置</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="filterTableData.length">
    </el-pagination>

    <el-dialog append-to-body title="创建账号" :visible.sync="dialogVisible" width="820px">
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item label="订单延迟显示时间" prop="delayTime" :rules="[{ required: true, message: '请输入0或正整数' },{ validator: valiDelayTime, trigger: 'blur' }]">
          以下买手账户在订单支付完成后<el-input style="width: 100px" v-model="form.delayTime"></el-input>分钟后可以查询 （0代表订单创建后即可以查询到）
        </el-form-item>
        <el-form-item label="买手账户" prop="buyerIdList">
          <el-select v-model="form.buyerIdList" multiple filterable placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in buyerList"
              :disabled="item.disabled"
              :key="item.buyerId"
              :label="item.buyerName"
              :value="item.buyerId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBuyerLevelList,
  getBuyerList,
  setBuyerLevel,
} from "./api";

export default {
  components: {
  },
  data() {
    return {
      queryForm: {
        buyerName: null,
        pageNo: 1,
        pageSize: 25,
      },
      buyerList: [],
      tableData: [],
      filterTableData: [],
      dialogVisible: false,
      form: {
        buyerLevelId: null,
        delayTime: null,
        buyerIdList: [],
      },
    };
  },
  mounted() {
    getBuyerList().then(res => {
      if (res.data && res.data.data) {
        this.buyerListData = res.data.data;
      }
    })
    this.getTableData()
  },
  methods: {
    search() {
      this.getTableData();
    },
    reset() {
      this.queryForm.buyerName = null;
      this.getTableData();
    },
    getTableData() {
      getBuyerLevelList({ buyerName: null }).then(res => {
        if (res.data && res.data.data) {
          this.tableDataOrigin = res.data.data;
          this.filterTableData = res.data.data;
          if (this.queryForm.buyerName) {
            this.filterTableData = res.data.data.filter(item => {
              return (item.buyerList || []).some(buyer => {
                if (buyer.buyerName.indexOf(this.queryForm.buyerName) > -1) {
                  return true;
                }
                return false;
              })
            });
          }
          this.tableData = this.filterTableData.slice((this.queryForm.pageNo - 1) * this.queryForm.pageSize, this.queryForm.pageSize);
        }
        
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      const index = (this.queryForm.pageNo - 1) * this.queryForm.pageSize;
      this.tableData = this.filterTableData.slice(index, index + this.queryForm.pageSize);
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      const index = (this.queryForm.pageNo - 1) * this.queryForm.pageSize;
      this.tableData = this.filterTableData.slice(index, index + this.queryForm.pageSize);
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            this.repeatSave = true;
            setBuyerLevel(this.form).then(res => {
              this.repeatSave = false;
              if (res.data.success) {
                this.$message.success('提交成功');
                this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message.error(res.data.data || res.data.message);
              }
            }).catch((err) => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
    showForm(row) {
      this.form.buyerLevelId = row.buyerLevelId;
      this.form.delayTime = row.delayTime;
      this.form.buyerIdList = (row.buyerList || []).map(item => item.buyerId);

      let otherBuyerList = [];
      this.tableDataOrigin.filter(item => item.buyerLevelId !== row.buyerLevelId).forEach(item => {
        otherBuyerList = otherBuyerList.concat((item.buyerList || []).map(buyer => buyer.buyerId))
      })

      this.buyerList = this.buyerListData.map(item => {
        if (otherBuyerList.indexOf(item.buyerId) > -1) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        return item;
      })
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
      
    },
    valiDelayTime(rule, value, callback) {
      if (!/^\d+$/.test(value)) {
        callback(new Error('请输入0或正整数'));
      } else {
        callback();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.buyer-name {
  white-space:nowrap;
  text-overflow:ellipsis;
  overflow:hidden; 
}
</style>
